import getDefaultState from './defaultState';

export default getDefaultState();



// WEBPACK FOOTER //
// ./src/store/modules/payments/clientPayments/state.js